class VideoComponent extends HTMLElement {
  connectedCallback() {
    if (this._initialised) return;
    this._initialised = true;

    this.videos = Array.from(this.querySelectorAll('video'));
    this.toggle = this.querySelector('[data-video-toggle], .video_banner_motion_toggle');
    this.toggleLabel = this.toggle ? this.toggle.querySelector('[data-video-toggle-label], [data-video-banner-toggle-label]') : null;
    this.handleToggleClick = this.handleToggleClick.bind(this);

    if (!this.videos.length || !this.toggle) return;

    this.setToggleState(false);
    this.toggle.addEventListener('click', this.handleToggleClick);
  }

  disconnectedCallback() {
    if (this.toggle && this.handleToggleClick) {
      this.toggle.removeEventListener('click', this.handleToggleClick);
    }
  }

  setToggleState(isPaused) {
    const label = isPaused ? 'Play video' : 'Pause video';
    this.toggle.setAttribute('aria-pressed', String(isPaused));
    this.toggle.setAttribute('aria-label', label);
    this.toggle.setAttribute('data-state', isPaused ? 'paused' : 'playing');

    if (this.toggleLabel) {
      this.toggleLabel.textContent = label;
    }
  }

  handleToggleClick(event) {
    event.preventDefault();
    event.stopPropagation();

    const shouldPause = this.toggle.getAttribute('aria-pressed') === 'false';

    this.videos.forEach((videoEl) => {
      if (shouldPause) {
        videoEl.pause();
        return;
      }

      const playPromise = videoEl.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    });

    this.setToggleState(shouldPause);
  }
}

window.customElements.get('video-component') || window.customElements.define('video-component', VideoComponent);
